import { GHLLanguageKeys as a } from "./ghl-ui.es285.js";
import o from "./ghl-ui.es1274.js";
const r = {
  name: a.danish,
  locale: o
};
export {
  r as date_da
};
